import { useState, useEffect, useCallback } from 'react';
import { EVENTS } from 'util/constants';
import useSafeUseProgress from './useSafeProgress';

export function useSceneLoaded() {
  const { safeActive } = useSafeUseProgress();
  const [isSceneLoaded, setIsSceneLoaded] = useState(false);
  const [isSceneFullyLoaded, setIsSceneFullyLoaded] = useState(false);
  const [isFirstRender, setIsFirstRender] = useState(true);

  const onLoadedScene = useCallback(() => {
    setIsSceneLoaded(true);
  }, []);

  useEffect(() => {
    window.addEventListener(EVENTS.SCENE_LOADED, onLoadedScene);

    return () => {
      window.removeEventListener(EVENTS.SCENE_LOADED, onLoadedScene);
    };
  }, []);

  useEffect(() => {
    if (!safeActive && isSceneLoaded && isFirstRender) {
      setIsSceneFullyLoaded(true);
      setIsFirstRender(false);
      setIsSceneLoaded(false);
    }
  }, [safeActive, isFirstRender]);

  return { sceneFirstFullyLoaded: isSceneFullyLoaded };
}
